// extracted by mini-css-extract-plugin
export default {"root":"account_creation_root__B4QUt","contain":"account_creation_contain__wjqer"};